import { computed, Ref } from "vue";
import { useStore } from "vuex";
import { useFeatureFlag } from "@/lib/useFeatureFlag";

import { Technician } from "@/typings/technician";

const MAX_TECHS = 15;
const LIMIT_MESSAGE = "Maximum of 15 technicians";

export function useMultiTechSelect(selectedIds?: Ref<number[]>) {
  const store = useStore();
  const isMultiTechEnabled = useFeatureFlag("multiple_technicians_ff_enabled");

  const isAtLimit = computed(() => {
    if (!selectedIds) return false;
    return selectedIds.value.length >= MAX_TECHS;
  });

  const limitHelperText = computed(() => {
    return isAtLimit.value ? LIMIT_MESSAGE : "";
  });

  function toTechProfileIds(userIds: number[]): number[] {
    const technicians: Technician[] = store.state.technicians;
    return userIds
      .map(
        (uid) =>
          technicians.find((t) => t.user_id === uid)?.technician_profile_id
      )
      .filter((id): id is number => id != null);
  }

  function primaryTechUserId(userIds: number[]): number | undefined {
    return userIds.length > 0 ? userIds[0] : undefined;
  }

  return {
    isMultiTechEnabled,
    isAtLimit,
    limitHelperText,
    toTechProfileIds,
    primaryTechUserId,
    MAX_TECHS
  };
}
